import { authActions } from "./auth-slice";
import { signup, login } from "../lib/api";
import { LoginSuccessResponse, userDataType } from "../types/user";

import { signupResponseType } from "../types/user";

const LOGIN_SUCCESS_MESSAGE = "Login successful!";
const SIGNUP_SUCCESS_MESSAGE = "Signed up successfully!";

// const LOGIN_EXPIRATION_DURATION_IN_SECONDS = 300;

export const signupAction = (userData: userDataType) => {
  return async (dispatch: any) => {
    try {
      const response: signupResponseType = await signup(userData);
      dispatch(
        authActions.signup({
          payload: response,
        })
      );
      return SIGNUP_SUCCESS_MESSAGE;
    } catch (error) {
      return error;
    }
  };
};

export const loginAction = (userData: userDataType) => {
  return async (dispatch: any) => {
    try {
      const response: LoginSuccessResponse = await login(userData);
      console.log(response);
      dispatch(
        authActions.login({
          token: response.access_token,
          userName: response.user.username,
        })
      );
      // dispatch(setupLogoutTimer(LOGIN_EXPIRATION_DURATION_IN_SECONDS*1000)) // Convert seconds to milliseconds
      return LOGIN_SUCCESS_MESSAGE;
    } catch (error) {
      return error;
    }
  };
};

export const logoutAction = () => {
  return async (dispatch: any) => {
    dispatch(authActions.clearLogoutTimer());
    dispatch(authActions.logout());
  };
};

export const setupLogoutTimer = (expirationTime: number) => (dispatch: any) => {
  const logoutTimer = setTimeout(() => {
    // Dispatch the logout action when the timer expires
    dispatch(authActions.logout());
  }, expirationTime);
  dispatch(authActions.setLogoutTimer(logoutTimer));
  return logoutTimer;
};
